import { render, staticRenderFns } from "./LoginDialog.vue?vue&type=template&id=4c79b0a1&scoped=true&"
import script from "./LoginDialog.vue?vue&type=script&lang=js&"
export * from "./LoginDialog.vue?vue&type=script&lang=js&"
import style0 from "./LoginDialog.vue?vue&type=style&index=0&id=4c79b0a1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c79b0a1",
  null
  
)

export default component.exports